/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {
  Check,
  RefreshCw,
  Info,
  Truck,
  FileBarChart,
  Clock,
  MapPin,
  X,
  Eye,
  EyeOff,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { applyStoreDraft } from "../../redux/store/store";

export default function ActivationElogistia() {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.StoreReducer);
  const isConnected =
    store.apielogistia !== null &&
    store.apielogistia !== "" &&
    store.apielogistia !== false &&
    store.apielogistia !== undefined;

  const [showApiKey, setShowApiKey] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const [data, setData] = useStoreFormDraft(store);

  // Configure SweetAlert to always appear on top
  const showAlert = (icon, title, text) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: t("activationCompanies.alerts.confirmButton"),
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `rgba(0,0,0,0.7)`,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.apielogistia) {
      await showAlert(
        "warning",
        t("activationCompanies.alerts.missingData.title"),
        t("activationCompanies.alerts.missingData.text"),
      );
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `https://api.elogistia.com/insertCommande/?
          apiKey=${data.apielogistia}
          &name=Test
          &firstname=User
          &mail=test@test.com
          &phone=0550123456
          &address=Rue Test
          &commune=ALGER%20CENTRE
          &fraisDeLivraison=0
          &remarque=Commande de test
          &stop_desk=1
          &wilaya=16
          &product=ProduitTest
          &price=1000
          &modeDeLivraison=1
          &IdCommande=TEST${Date.now()}
          &poids=1`.replace(/\s+/g, ""),
        {
          method: "POST",
        },
      );

      const responseText = await response.text();

      console.log("Status:", response.status);
      console.log("Response:", responseText);

      if (!response.ok) {
        throw new Error(`Erreur API: ${response.status}`);
      }

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));
      setData(data);

      setLoading(false);

      await showAlert(
        "success",
        t("activationCompanies.alerts.activationSuccess.title"),
        "",
      );
    } catch (error) {
      console.error("❌ Erreur Elogistia :", error);

      setLoading(false);

      await showAlert(
        "error",
        t("activationCompanies.alerts.activationFailed.title"),
        error.message,
      );
    }
  };

  const handleDeactivate = async () => {
    const result = await Swal.fire({
      icon: "warning",
      title: t("activationCompanies.alerts.deactivateConfirm.title"),
      text: t("activationCompanies.alerts.deactivateConfirm.text"),
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.confirmText",
      ),
      cancelButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.cancelText",
      ),
      backdrop: `rgba(0,0,0,0.7)`,
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });

    if (result.isConfirmed) {
      try {
        const updatedData = { ...data };
        delete updatedData.apielogistia;

        await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
        dispatch(applyStoreDraft(store, updatedData));
        setData(updatedData);

        await Swal.fire({
          icon: "success",
          title: t("activationCompanies.alerts.deactivateSuccess.title"),
          text: t("activationCompanies.alerts.deactivateSuccess.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
          customClass: {
            popup: "swal-popup-on-top",
          },
        });
      } catch (error) {
        console.error("Error during deactivation:", error);
        await Swal.fire({
          icon: "error",
          title: t("activationCompanies.alerts.deactivateError.title"),
          text: t("activationCompanies.alerts.deactivateError.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
    }
  };

  return (
    <div className="min-h-[400px] h-fit p-6 bg-white dark:!bg-[#181819] transition-colors duration-300">
      <h3 className="text-lg font-semibold text-[#9e68ba] mb-0 dark:!text-[#b58fd1]">
        {t("activationCompanies.elogistia.title")}
      </h3>

      <Form onSubmit={handleSubmit}>
        <div className="mb-4">
          <p className="font-medium text-gray-700 mb-3 dark:!text-gray-300">
            {t("activationCompanies.elogistia.form.label")}
          </p>
          <Form.Group className="mb-3">
            <div className="relative mb-3">
              <Form.Control
                type={showApiKey ? "text" : "password"}
                placeholder={t(
                  "activationCompanies.elogistia.form.placeholder",
                )}
                value={data.apielogistia || ""}
                onChange={(e) =>
                  setData({ ...data, apielogistia: e.target.value })
                }
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200 focus:ring-2 focus:ring-[#9e68ba] mr-[32px] dark:!placeholder-gray-500"
                style={{
                  direction: i18n.dir(),
                  textAlign: i18n.dir() === "rtl" ? "right" : "left",
                  width: "94%",
                }}
              />
              <button
                type="button"
                onClick={() => setShowApiKey(!showApiKey)}
                className="absolute inset-y-0 right-0 flex items-center pr-3
                  text-gray-500 hover:text-[#9e68ba] dark:text-gray-400"
              >
                {showApiKey ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <Form.Text className="text-muted dark:!text-gray-400">
              {t("activationCompanies.elogistia.form.helperText")}
            </Form.Text>
          </Form.Group>
        </div>

        {/* Tips Section */}
        <div
          className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] mb-4 
                    dark:!bg-[#181919] dark:!border-[#3c3a3d]"
        >
          <h4
            className="font-medium text-[#9e68ba] text-xl mb-2 d-flex align-items-center 
                     dark:!text-[#b58fd1]"
          >
            <Info size={18} className="ml-2" />
            {t("activationCompanies.elogistia.tips.title")}
          </h4>
          <ul className="text-sm text-gray-700 dark:!text-gray-300 space-y-2 mr-5 list-disc">
            <li className="d-flex align-items-start mb-2">
              <Truck
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.elogistia.tips.tip1")}</span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <Clock
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.elogistia.tips.tip2")}</span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <MapPin
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.elogistia.tips.tip3")}</span>
            </li>
            <li className="d-flex align-items-start">
              <FileBarChart
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.elogistia.tips.tip4")}</span>
            </li>
          </ul>
        </div>

        <div className="d-flex justify-content-between mt-4">
          {!isConnected ? (
            <Button
              type="submit"
              disabled={loading}
              className="d-flex align-items-center justify-content-center 
                   dark:!bg-[#9e68ba] dark:!border-[#9e68ba] dark:hover:!bg-[#814a9f]"
              style={{
                backgroundColor: "rgb(141, 93, 167)",
                borderColor: "rgb(141, 93, 167)",
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("activationCompanies.elogistia.buttons.submitting")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("activationCompanies.elogistia.buttons.submit")}
                </>
              )}
            </Button>
          ) : (
            <Button
              variant="danger"
              className="d-flex align-items-center justify-content-center 
                   dark:!bg-red-600 dark:hover:!bg-red-700"
              onClick={handleDeactivate}
              style={{
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              <X className="ml-2" size={18} />
              {t("activationCompanies.elogistia.buttons.cancel")}
            </Button>
          )}
        </div>
      </Form>
    </div>
  );
}
